import React from "react";
import { ToastContainer } from "react-toastify";

import MetaSocialAdsLayout from "./components/MetaSocialAdsLayout";

const MetaSocialAdsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <MetaSocialAdsLayout {...props} />
    </>
  );
};

export default MetaSocialAdsApp;
